import { stripMarkdown } from '@helpers/format'
import { getTutorVisualStyle } from '@helpers/courseUtils'
import Image from '@components/Image'
import { ArrowPathRoundedSquareIcon } from '@heroicons/react/24/outline'
import { Tooltip, TooltipContent, TooltipTrigger } from '@components/ui/tooltip'

const CommunityTutorCard = ({
  tutorId = '',
  name,
  description,
  imageUrl,
  userName,
  socratic,
  stemModeEnabled,
  copiesCount,
  children,
  knowledgeBaseEnabled,
  suggestionsEnabled
}) => {
  const formattedDescription = stripMarkdown(description)
  const { emoji, gradientFrom, gradientTo } = getTutorVisualStyle(tutorId)
  const spanBadgeClassName = 'cursor-pointer p-1 px-2 bg-secondary text-secondary-foreground rounded-[4px] font-medium font-dm-mono text-xs flex items-center'

  return (
    <div className={"font-dm-sans grow flex flex-col sm:flex-row gap-3 border p-5 rounded-lg bg-background h-full"}>

      <Choose>
        <When condition={imageUrl}>
          <Image
            className='size-32 shrink-0 rounded-sm bg-gray-200 object-cover'
            src={imageUrl}
            placeholder={<div className='size-32 shrink-0 rounded-sm bg-gray-200'></div>}
          />
        </When>
        <Otherwise>
          <div
            className='size-32 shrink-0 rounded-sm flex items-center justify-center'
            style={{ background: `linear-gradient(135deg, ${gradientFrom}, ${gradientTo})` }}
          >
            <span className='text-3xl'>{emoji}</span>
          </div>
        </Otherwise>
      </Choose>

      <div className='flex flex-col gap-1'>
        <h2 className='text-sm font-semibold line-clamp-1'>{name}</h2>
        <p className='text-sm line-clamp-2 break-all'>{formattedDescription}</p>
        <If condition={userName}>
          <p className='text-sm text-muted-foreground'>By {userName}</p>
        </If>
        <div className='flex flex-wrap gap-1 mt-2'>
          <If condition={copiesCount}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className={spanBadgeClassName}>
                  <ArrowPathRoundedSquareIcon className='size-3 mr-1' />
                  {copiesCount}
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <p>Copies</p>
              </TooltipContent>
            </Tooltip>
          </If>
          <If condition={stemModeEnabled}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className={spanBadgeClassName}>🧪</span>
              </TooltipTrigger>
              <TooltipContent>
                <p>STEM Mode</p>
              </TooltipContent>
            </Tooltip>
          </If>
          <If condition={socratic}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className={spanBadgeClassName}>🧠</span>
              </TooltipTrigger>
              <TooltipContent>
                <p>Socratic Mode</p>
              </TooltipContent>
            </Tooltip>
          </If>
          <If condition={knowledgeBaseEnabled}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className={spanBadgeClassName}>📚</span>
              </TooltipTrigger>
              <TooltipContent>
                <p>Knowledge Base</p>
              </TooltipContent>
            </Tooltip>
          </If>
          <If condition={suggestionsEnabled}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className={spanBadgeClassName}>💬</span>
              </TooltipTrigger>
              <TooltipContent>
                <p>Suggestions</p>
              </TooltipContent>
            </Tooltip>
          </If>
        </div>
        {children}
      </div>
    </div>
  )
}

export default CommunityTutorCard
